import { HEADER, Show_Header, STREAM, SHOW_FIXED_NAV, HEADER_BG_PROPERTIES, Scroll_Header, } from "@frameworks/web/redux/interfaces/iHeader";
const initState = {
    data: {
        mainHeaderItem: {},
        subHeaderItem: {},
        img: "",
        menuItem: [],
    },
    stream: [
        {
            symbol: "",
            curPrice: "",
            changePrice: "",
            changePercentage: "",
        },
    ],
    showHeader: true,
    scrollHeader: false,
    showFixedNavMob: true,
    headerBG_Properties: {},
};
const header = (state = initState, action) => {
    switch (action.type) {
        case HEADER:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case STREAM:
            return Object.assign(Object.assign({}, state), { stream: action.payload.stream });
        case Show_Header:
            return Object.assign(Object.assign({}, state), { showHeader: action.payload.showHeader });
        case Scroll_Header:
            return Object.assign(Object.assign({}, state), { scrollHeader: action.payload.scrollHeader });
        case SHOW_FIXED_NAV:
            return Object.assign(Object.assign({}, state), { showFixedNavMob: action.payload.showFixedNavMob });
        case HEADER_BG_PROPERTIES:
            return Object.assign(Object.assign({}, state), { headerBG_Properties: action.payload.headerBG_Properties });
        default:
            return Object.assign({}, state);
    }
};
export default header;
